var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({},on),[_c('v-btn',{attrs:{"icon":"","x-small":""},on:{"click":_vm.sendToMSBC}},[_c('v-icon',{attrs:{"color":"success"}},[_vm._v(" play_circle_filled ")])],1)],1)]}}])},[_vm._v(" Send to MSBC ")])}
var staticRenderFns = []

export { render, staticRenderFns }